import includes from 'lodash/includes';
import Request from '../../common/api/request';
import ServiceResultFactory from '../../common/api/ServiceResultFactory';

const getGraphQLUrl = baseUrl => `${baseUrl}graphql/`;

const getlocale = (multilingual, locale) => {
  let currentLocale = locale;
  const availableLocales = multilingual.map(x => x.locale.toLowerCase());
  if (!includes(availableLocales, currentLocale.toLowerCase())) {
    currentLocale = 'en-GB';
  }
  return currentLocale;
};

const constructQuery = (eventEditionId, organisationId, includeUnpublishedProducts = true) =>
  `{
  exhibitingOrganisation(eventEditionId:"${eventEditionId}", organisationId:"${organisationId}"){
      id  
      productsAndServices { id }
      socialMedia {url, name}
      isNew
      organisationId
      accompanyingWebsiteUrl
      packageId
      companyName
      contactEmail
      website
      phone
      hideAddress
      extraCharacteristics { id }
      multilingual {
       logoUrl
       coverImageUrl
       locale     
       displayName
       description
       showObjective
       sortAlias
       representedBrands {name}
       addressLine1
       addressLine2
       stateProvince
       city
       countryCode
       postcode
       country
       additionalAddresses {
         addressLine1
         addressLine2
         stateProvince
         city
         countryCode
         postcode
        }
      }
      exhibitingProducers {
        id
        firstName
        lastName
      }
      representedProducers {
        id
        firstName
        lastName
      }
      directors,
      filterCategories{      
        multilingual{
          name,
          locale,
        }
      responses{
        answerId,
        parentId,
        taxonomyId,
        multilingual{
          name,
          locale
        }
      },
      id
    }
    products(includeUnpublished:${includeUnpublishedProducts}){
      id
      exhibitingOrganisationId
      imageUrl
      isInnovative
      isNew
      videoId
      video{
            id
            defaultThumbnailUrl
            customThumbnailUrl
            status
          }
      isPublished
      lastUpdatedAt
      producerDetails {
        id
        firstName
        lastName
      }
      multilingual {
        title
        description
        locale
      }
      filterAttributes{
        id
        questionText{
          locale
          name
        }
        textualResponses{
          locale
          textResponse
        }
        responses
        {
          answerId
          answerText{
            locale
            name
          }
        }
        sortOrder
      }
      attributes {
        id
        questionText{
          locale
          name
        }
        responses{
          answerId
          answerText{
            locale
            name
          }
        }
       textualResponses{
        locale
        textResponse
      }
        sortOrder
      } 
    }
    stands{
      name
    }
    sharers {
      id
      organisationGuid
      name
      isActive
      packageId
      multilingual {
        name
        locale
      }
    }
    mainStandHolder {
      organisationGuid
      id
      packageId
      multilingual {
        name
        locale
      }
      sharers {
        id
        organisationGuid
        name
        isActive
        packageId
        multilingual {
          name
          locale
        }
      }
    }      
  }
}`;

const translate = (exhOrg, interfaceLocale) => {
  // eslint-disable-next-line no-param-reassign
  exhOrg.categories = [];

  exhOrg.filterCategories.forEach((filterCategory) => {
    const category = {
      id: filterCategory.id,
      name: '',
      responses: []
    };

    // eslint-disable-next-line no-param-reassign
    interfaceLocale = getlocale(filterCategory.multilingual, interfaceLocale);
    filterCategory.multilingual.forEach((multi) => {
      if (multi.locale.toLowerCase() === interfaceLocale.toLowerCase()) {
        category.name = multi.name;
      }
    });

    filterCategory.responses.forEach((response) => {
      response.multilingual.forEach((multi) => {
        if (multi.locale.toLowerCase() === interfaceLocale.toLowerCase()) {
          category.responses.push({
            name: multi.name,
            taxonomyId: response.taxonomyId
          });
        }
      });
    });

    exhOrg.categories.push(category);
  });

  return exhOrg;
};
const getExhibitingOrganisationResponse = (response, interfaceLocale) => {
  if (response !== undefined && response.body !== undefined && response.body.errors !== undefined && response.body.errors.length > 0) {
    return {
      categories: [],
      filterCategories: [],
      exhibitingProducers: [],
      representedProducers: [],
      directors: [],
      additionalAddresses: [],
      product: [],
      mainStandHolder: {},
      sharer: []
    };
  }
  return translate(
    response.body.data.exhibitingOrganisation,
    interfaceLocale
  );
};

const exhibitingOrganisation = (
  baseApiUrl,
  eventEditionId,
  organisationId,
  interfaceLocale = 'en-GB',
  includeUnpublishedProducts
) => {
  const url = getGraphQLUrl(baseApiUrl);
  const query = constructQuery(eventEditionId, organisationId, includeUnpublishedProducts);

  return Request.publicGraphqlRequest(url, query)
    .then(response => getExhibitingOrganisationResponse(response, interfaceLocale))
    .catch(result =>
      ServiceResultFactory.fromError(interfaceLocale, result, false));
};

const getMainsStandHolderStands = (baseUrl, mshId, interfaceLocale) => {
  const query = `
  {
    exhibitingOrganisationBasicDetails(id:"${mshId}", locale:"${interfaceLocale}"){
      stands{
        name
      }
    }
  }`;

  return Request
    .graphqlRequest(getGraphQLUrl(baseUrl), query, {})
    .then(result => ServiceResultFactory.fromGraphqlSuccess({ ...result }, interfaceLocale, 'exhibitingOrganisationBasicDetails'))
    .catch(result => ServiceResultFactory.fromError(interfaceLocale, result, true));
};
export default {
  exhibitingOrganisation, getMainsStandHolderStands
};
